import { STATUS } from '../../../utils/api/sharedfunction';

/**
 * Interpret POST /save outcome for Quick Upload (success, duplicate, or already-finalized race).
 * Backend returns alreadyFinalized when the registered scanning row was soft-deleted by a concurrent finalize.
 */
export function interpretQuickUploadSaveResult(saveRes) {
  if (saveRes?.status === STATUS.SUCCESS) {
    const isDuplicate = !!(saveRes.data?.duplicate || saveRes.data?.alreadyFinalized);
    return {
      ok: true,
      isDuplicate,
      payload: saveRes.data,
      snackbarMessage: isDuplicate
        ? 'File already exists in this folder (linked to existing)'
        : 'File uploaded successfully',
      snackbarSeverity: isDuplicate ? 'warning' : 'success',
    };
  }

  return {
    ok: false,
    isDuplicate: false,
    payload: null,
    error: saveRes?.error || 'Failed to save file after scan',
  };
}
